import { render } from "./jobDetail.vue?vue&type=template&id=59019e54&scoped=true"
import script from "./jobDetail.vue?vue&type=script&lang=js"
export * from "./jobDetail.vue?vue&type=script&lang=js"

import "./jobDetail.vue?vue&type=style&index=0&id=59019e54&lang=scss&scoped=true"
import "./jobDetail.vue?vue&type=style&index=1&id=59019e54&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59019e54"]])

export default __exports__